module.exports = __webpack_public_path__ + "static/media/MaterialIcons-Regular.570eb838.woff2";